import {
  FGCustomInput,
  FGTextInput,
  FieldGroup,
  IDataTableColumn,
  useGridState,
} from "nsitools-react";
import * as React from "react";
import { useParams } from "react-router";
import styled from "styled-components";

import { ClubApi, DrupalClubDto } from "../../../api";
import { PageContainer } from "../../../components";
import { useApiService, useCrudApi, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { DrupalDataTable } from "../../common";
import { DrupalFormGenerator } from "../../common/DrupalFormGenerator";
import { DrupalFieldSet } from "../../common/DurpalFieldSet";
import { DrupalPersonInfoCard } from "./DrupalPersonInfoCard";

export interface IDrupalClubDetailPageProps {}
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const DrupalClubDetailPage: React.FunctionComponent<IDrupalClubDetailPageProps> = () => {
  const { id } = useParams<{ id: string }>();

  const clubId = React.useMemo(() => +id, [id]);
  const { t } = useTl();

  const api = useApiService(ClubApi);

  const tableState = useGridState<any>({
    serverMode: false,
    enablePagination: true,
    enableFilter: false,
    availablePageSizes: [10, 25, 50],
    pageSize: 10,
  });

  //===================== Getting Data ===========================

  const { data, loading, saving } = useCrudApi<DrupalClubDto>(
    React.useMemo(
      () => ({
        getApiFn: async (apiId = clubId) => {
          const res = await api.getDrupalClub(apiId);
          tableState.setData(res?.breeds);
          return res;
        },
        saveApiFn: () => () => {},
        deleteApiFn: () => {},
      }),
      [api, clubId, tableState]
    ),
    [clubId]
  );

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.BreedName),
        fieldName: "name",
      },
      {
        header: () => t(ETLCodes.BreedGroupLabel),
        fieldName: "breedGroupLabel",
      },
    ],
    [t]
  );

  // React.useEffect(() => {
  //   tableState.setData(data?.breeds);
  // }, [data, tableState]);

  //============================= Form ==========================
  return (
    <PageContainer>
      <DrupalFormGenerator
        initialValues={data}
        editMode={false}
        onSubmit={() => {}}
        loading={loading}
        saving={saving}
        hideButtons={true}
      >
        <FieldGroup
          columns={2}
          fieldsetProps={{ divider: false, title: t(ETLCodes.ClubInfo) }}
        >
          <FieldGroup>
            <FGCustomInput label={t(ETLCodes.Name)}>
              {() => <a href={data?.website}>{data?.name}</a>}
            </FGCustomInput>
            <FGTextInput label={t(ETLCodes.Email)} name="email" />
            <FGTextInput label={t(ETLCodes.PhoneNumber)} name="phoneNumber" />
          </FieldGroup>
        </FieldGroup>
      </DrupalFormGenerator>
      <DrupalFieldSet title={t(ETLCodes.Breeds)}>
        <DrupalDataTable
          tableState={tableState}
          loading={loading}
          columns={columns}
        />
      </DrupalFieldSet>
      <DrupalFieldSet title={t(ETLCodes.Administrators)}>
        <Container>
          {data?.chairmans?.map((c, key) => (
            <DrupalPersonInfoCard
              key={key}
              person={c}
              title={t(ETLCodes.Chairman)}
            />
          ))}
          {data?.secretaries?.map((c, key) => (
            <DrupalPersonInfoCard
              key={key}
              person={c}
              title={t(ETLCodes.GeneralSecretary)}
            />
          ))}
        </Container>
      </DrupalFieldSet>
    </PageContainer>
  );
};
